module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-Regular.351d8f1c.ttf";